import { WatcherType } from "../types/watcherType";

export const watcherAccountType = (props : WatcherType) => {
    const { watcher, currentStep, fields, setValue  } = props;
        let process =  [...fields];
        process = process.map((section, idx) => {
                if (!section.fields || idx !== currentStep) return section
                setValue("financialEntity", "")
                let fields = [
                    ...section?.fields.map((field: any) => {
                        if (
                            field.name === "financialEntity"
                        ) {
                            return { ...field, disabled : false  };
                        }
                        return field;
                    }),
                ];
                if (watcher === "DAVIPLATA") {
                    fields = fields.map((field: any) => {
                        if (field.name === "financialEntity") {
                            return { ...field, disabled: true };
                        }
                        return field;
                    });
                    setValue("financialEntity", "51");
                }
                if (watcher === " CUENTA DE AHORROS SUBSIDIOS") {
                    fields = fields.map((field: any) => {
                        if (field.name === "financialEntity") {
                            return { ...field, disabled: true };
                        }
                        return field;
                    });
                    setValue("financialEntity", "07");
                }
                return { ...section, fields };
            }
        );

        return process;
};